import React from 'react';
import './AuthInput.css';
import HideIcon from '../../assets/icons/Hide.svg';
import ShowIcon from '../../assets/icons/Show.svg';
import DeleteAllIcon from '../../assets/icons/delete_all.svg';

interface AuthInputProps {
  type: "text" | "password" | "email";
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  isValid?: boolean; // Make isValid optional
  showPassword?: boolean;
  onTogglePassword?: () => void;
  multiline?: boolean;
  maxLength?: number;
  errorMessage?: string;
}

const AuthInput: React.FC<AuthInputProps> = ({
  type,
  placeholder,
  value,
  onChange,
  isValid = true, // Default isValid to true
  showPassword,
  onTogglePassword,
  multiline = false,
  maxLength,
}) => {
  const handleDeleteAll = () => {
    onChange('');
  };

  if (multiline) {
    return (
      <textarea
        className={`auth-input auth-input-multiline ${!isValid ? 'invalid' : ''}`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        maxLength={maxLength}
      />
    );
  }

  return (
    <div className={`auth-input-container ${!isValid ? 'invalid' : ''}`}>
      <input
        type={type === 'password' && showPassword ? 'text' : type}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="auth-input"
      />
      {type === 'password' && onTogglePassword && (
        <img
          src={showPassword ? ShowIcon : HideIcon}
          alt={showPassword ? 'Hide password' : 'Show password'}
          className="password-toggle"
          onClick={onTogglePassword}
        />
      )}
      {type === 'text' && value.length > 0 && (
        <img
          src={DeleteAllIcon}
          alt="Delete all"
          className="delete-all-icon"
          onClick={handleDeleteAll}
        />
      )}
    </div>
  );
};

export default AuthInput;
